import Header from './components/Header';
import MemeJs from './components/Meme.js';
import './App.css';

function App() {
	return (
		<div className="App">
			<Header />
			<main>
				<MemeJs />
			</main>
		</div>
	);
}

export default App;
